import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Logo Component - Elegant text-only logo with gradient
 * Clean design without icon, cursive subtitle
 */
const Logo = ({ onClick, showSubtitle = true, size = 'medium' }) => {
  const sizes = {
    small: {
      titleSize: '1rem',
      subtitleSize: '0.55rem',
      gap: 0.3,
    },
    medium: {
      titleSize: '1.15rem',
      subtitleSize: '0.65rem',
      gap: 0.4,
    },
    large: {
      titleSize: '1.4rem',
      subtitleSize: '0.75rem',
      gap: 0.5,
    },
  };

  const s = sizes[size] || sizes.medium;

  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.2s ease-in-out',
        '&:hover': onClick ? {
          opacity: 0.85,
          transform: 'translateY(-1px)',
        } : {},
      }}
    >
      {/* Main Title */}
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: { xs: s.titleSize, sm: `calc(${s.titleSize} + 0.05rem)` },
          lineHeight: 1.1,
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          letterSpacing: '-0.01em',
        }}
      >
        AgenTriPlanner
      </Typography>
      
      {/* Subtitle - Cursive style */}
      {showSubtitle && (
        <Typography
          sx={{
            fontSize: { xs: s.subtitleSize, sm: `calc(${s.subtitleSize} + 0.03rem)` },
            color: 'text.secondary',
            lineHeight: 1,
            fontFamily: '"Dancing Script", "Pacifico", cursive',
            fontWeight: 500,
            letterSpacing: '0.02em',
            mt: s.gap,
            opacity: 0.8,
          }}
        >
          Your Agentic Trip Planner
        </Typography>
      )}
    </Box>
  );
};

export default Logo;
